import createIcon from '../../createIcon';

/**
 * @component @name AcUnit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTFIMTcuODNMMjEuMDcgNy43NkwxOS42NiA2LjM0TDE1IDExSDEzVjlMMTcuNjYgNC4zNEwxNi4yNCAyLjkzTDEzIDYuMTdWMkgxMVY2LjE3TDcuNzYgMi45M0w2LjM0IDQuMzRMMTEgOVYxMUg5TDQuMzQgNi4zNEwyLjkzIDcuNzZMNi4xNyAxMUgyVjEzSDYuMTdMMi45MyAxNi4yNEw0LjM0IDE3LjY2TDkgMTNIMTFWMTVMNi4zNCAxOS42Nkw3Ljc2IDIxLjA3TDExIDE3LjgzVjIySDEzVjE3LjgzTDE2LjI0IDIxLjA3TDE3LjY2IDE5LjY2TDEzIDE1VjEzSDE1TDE5LjY2IDE3LjY2TDIxLjA3IDE2LjI0TDE3LjgzIDEzSDIyVjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AcUnit = createIcon('AcUnit', [
  [
    'path',
    {
      d: 'M22 11H17.83L21.07 7.76L19.66 6.34L15 11H13V9L17.66 4.34L16.24 2.93L13 6.17V2H11V6.17L7.76 2.93L6.34 4.34L11 9V11H9L4.34 6.34L2.93 7.76L6.17 11H2V13H6.17L2.93 16.24L4.34 17.66L9 13H11V15L6.34 19.66L7.76 21.07L11 17.83V22H13V17.83L16.24 21.07L17.66 19.66L13 15V13H15L19.66 17.66L21.07 16.24L17.83 13H22V11Z',
      key: '1n2kgw',
    },
  ],
]);

export default AcUnit;
